export const DidGroupRenameInfo = () =>
  'Please note that DID-Group names have to be unique.';
